import React from 'react';
import { Container, SubWrap } from 'styles';
import { NoticeList, Pagination, SubTitle } from 'components';

function ArchiveView({ list, archiveList, paginationRequest, paginationResult, setPaginationRequest }) {
  return (
    <Container $gap={48}>
      <SubWrap $type="first">
        <SubTitle title={list.subject} desc={list.subjectDesc} />
        <NoticeList list={archiveList} downloadLabel={list.downloadLabel} onClick={(item) => console.debug('download')} />
      </SubWrap>
      <Pagination paginationRequest={paginationRequest} paginationResult={paginationResult} setPaginationRequest={setPaginationRequest} />

    </Container>
  );
}

export default ArchiveView;
